import { createStitches } from '@stitches/react';
import { themes, breakpoints } from './index';

export const {
  config,
  styled,
  css,
  globalCss,
  keyframes,
  getCssText,
  theme,
  createTheme,
} = createStitches({
  theme: {
    colors: {
      // Default White & Black
      white: themes.rainbow.white,
      black: themes.rainbow.black,

      // Light Theme
      lightText: themes.light.text,
      lightStrokebar: themes.light.strokebar,
      lightCard: themes.light.card,
      lightHeader: themes.light.header,
      lightBackground: themes.light.background,
      lightSidebar: themes.light.sidebar,

      // Dark Theme
      darkText: themes.dark.text,
      darkStrokebar: themes.dark.strokebar,
      darkCard: themes.dark.card,
      darkHeader: themes.dark.header,
      darkBackground: themes.dark.background,
      darkSidebar: themes.dark.sidebar,

      // Rainbow Colors
      gray50: themes.rainbow.gray[50],
      gray100: themes.rainbow.gray[100],
      gray200: themes.rainbow.gray[200],
      gray300: themes.rainbow.gray[300],
      gray400: themes.rainbow.gray[400],
      gray500: themes.rainbow.gray[500],
      gray600: themes.rainbow.gray[600],
      gray700: themes.rainbow.gray[700],
      gray800: themes.rainbow.gray[800],
      gray900: themes.rainbow.gray[900],

      blue50: themes.rainbow.blue[50],
      blue100: themes.rainbow.blue[100],
      blue200: themes.rainbow.blue[200],
      blue300: themes.rainbow.blue[300],
      blue400: themes.rainbow.blue[400],
      blue500: themes.rainbow.blue[500],
      blue600: themes.rainbow.blue[600],
      blue700: themes.rainbow.blue[700],
      blue800: themes.rainbow.blue[800],
      blue900: themes.rainbow.blue[900],

      sucess50: themes.rainbow.sucess[50],
      sucess100: themes.rainbow.sucess[100],
      sucess200: themes.rainbow.sucess[200],
      sucess300: themes.rainbow.sucess[300],
      sucess400: themes.rainbow.sucess[400],
      sucess500: themes.rainbow.sucess[500],
      sucess600: themes.rainbow.sucess[600],
      sucess700: themes.rainbow.sucess[700],
      sucess800: themes.rainbow.sucess[800],
      sucess900: themes.rainbow.sucess[900],

      link50: themes.rainbow.link[50],
      link100: themes.rainbow.link[100],
      link200: themes.rainbow.link[200],
      link300: themes.rainbow.link[300],
      link400: themes.rainbow.link[400],
      link500: themes.rainbow.link[500],
      link600: themes.rainbow.link[600],
      link700: themes.rainbow.link[700],
      link800: themes.rainbow.link[800],
      link900: themes.rainbow.link[900],

      warning50: themes.rainbow.warning[50],
      warning100: themes.rainbow.warning[100],
      warning200: themes.rainbow.warning[200],
      warning300: themes.rainbow.warning[300],
      warning400: themes.rainbow.warning[400],
      warning500: themes.rainbow.warning[500],
      warning600: themes.rainbow.warning[600],
      warning700: themes.rainbow.warning[700],
      warning800: themes.rainbow.warning[800],
      warning900: themes.rainbow.warning[900],

      error50: themes.rainbow.error[50],
      error100: themes.rainbow.error[100],
      error200: themes.rainbow.error[200],
      error300: themes.rainbow.error[300],
      error400: themes.rainbow.error[400],
      error500: themes.rainbow.error[500],
      error600: themes.rainbow.error[600],
      error700: themes.rainbow.error[700],
      error800: themes.rainbow.error[800],
      error900: themes.rainbow.error[900],

      yellow50: themes.rainbow.yellow[50],
      yellow100: themes.rainbow.yellow[100],
      yellow200: themes.rainbow.yellow[200],
      yellow300: themes.rainbow.yellow[300],
      yellow400: themes.rainbow.yellow[400],
      yellow500: themes.rainbow.yellow[500],
      yellow600: themes.rainbow.yellow[600],
      yellow700: themes.rainbow.yellow[700],
      yellow800: themes.rainbow.yellow[800],
      yellow900: themes.rainbow.yellow[900],

      gbmSky: themes.rainbow.gbm.sky,
      gbmOcean: themes.rainbow.gbm.ocean,
      gbmBlue: themes.rainbow.gbm.blue,
    },

    fontSizes: {},

    breakpoints,
  },

  utils: {
    size: (value: string | number) => ({
      width: value,
      height: value,
    }),

    maxSize: (value: string | number) => ({
      maxWidth: value,
      maxHeight: value,
    }),

    minSize: (value: string | number) => ({
      minWidth: value,
      minHeight: value,
    }),
  },

  media: {
    xs: '(min-width: 320px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    xxl: '(min-width: 1400px)',
    xxxl: '(min-width: 1872px)',
  },
});
